import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowLanes24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconWorkflowLanes24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 4H4a.5.5 0 0 0-.5.5V7h6V4.5A.5.5 0 0 0 9 4m-5.5 7.5v-3h6v3zm0 6V20a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-2.5zm0-1.5h6v-3h-6zM4 2.5a2 2 0 0 0-2 2V20a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4.5a2 2 0 0 0-2-2zM20 4h-5a.5.5 0 0 0-.5.5V7h6V4.5A.5.5 0 0 0 20 4m.5 4.5h-6v3h6zm-6 7V13h6v2.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5m.5-13a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowLanes24);
